/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherOpexDto } from '../../models/backend-other-opex-dto';
import { BackendOtherOpexRequestDto } from '../../models/backend-other-opex-request-dto';

export interface OpexesOtheropexCreate$FormData$Params {
  body: BackendOtherOpexRequestDto;
}

export function opexesOtheropexCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: OpexesOtheropexCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, opexesOtheropexCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOtherOpexDto>;
    }),
  );
}

opexesOtheropexCreate$FormData.PATH = '/api/opexes/otheropex/';
